import { IVector3Like } from '@babylonjs/core/Maths/math.like';
import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import remove from 'lodash/remove';
import find from 'lodash/find';

import { SystemLayer } from '../System/systemLayer';
import { UiFollowPoint } from './uiFollowPoint';

export interface HoverPoint {
    point: IVector3Like,
    text: string,
}

export interface IComment extends HoverPoint {
    id: string,
    author: string,
    date: Date,
}

export interface I3DComment {
    id: string,
    followPoint: UiFollowPoint,
}

export class UiComments {
    protected system: SystemLayer;

    protected container: HTMLElement;

    constructor(
        system: SystemLayer,
        container: HTMLElement,
        comments: IComment[],
    ) {
        this.system = system;
        this.container = container;
        comments.forEach((c) => {
            this.addComment(c);
        });

        //* For test purpose
        // this.addComment({ point: Vector3.Zero(), text: 'Hand made leather' });
    }

    public getHtmlFromComment(c: IComment): string {
        return `<div class="naker-hover-author">@${c.author} - ${c.date.toLocaleDateString()}</div><div>${c.text}</div>`
    }

    private _3Dcomments: I3DComment[] = [];

    private editPoint(followPoint: UiFollowPoint, comment: IComment) {
        let html = this.getHtmlFromComment(comment)
        const { point } = comment
        const vec = new Vector3(point.x, point.y, point.z)
        followPoint.editPoint(vec, html);
    }

    public addComment(comment: IComment): I3DComment {
        const followPoint = new UiFollowPoint(this.system, this.container);
        followPoint.show();
        followPoint.keepPointVisible = true;
        this.editPoint(followPoint, comment)
        const new3DComment = { ...comment, followPoint }
        this._3Dcomments.push(new3DComment);
        followPoint.point.addEventListener('mouseenter', () => {
            followPoint.showAnim();
        });
        followPoint.point.addEventListener('mouseleave', () => {
            followPoint.shown = false;
            setTimeout(() => {
                //* In case point is hovered again and shown
                if (!followPoint.shown) followPoint.hideAnim();
            }, 1000);
        });
        return new3DComment
    }

    public removeComment(id: string): void {
        const removedPoint: I3DComment = remove(this._3Dcomments, (c) => c.id === id)[0];
        if (removedPoint) removedPoint.followPoint.delete();
    }

    public editComment(comment: IComment): void {
        const comment3D: I3DComment = find(this._3Dcomments, (c) => c.id === comment.id)
        this.editPoint(comment3D.followPoint, comment)
    }

    public showComment(id: string) {
        const comment: I3DComment = find(this._3Dcomments, (c) => c.id === id)
        comment.followPoint.showAnim()
    }

    public hideComment(id: string) {
        const comment: I3DComment = find(this._3Dcomments, (c) => c.id === id)
        comment.followPoint.hideAnim()
    }
}
